import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCalendarAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 19a1 1 0 1 0 .0002-2A1 1 0 0 0 12 19Zm5 0a1 1 0 1 0 .0002-2A1 1 0 0 0 17 19Zm0-4a1 1 0 1 0 .0002-2A1 1 0 0 0 17 15Zm-5 0a1 1 0 1 0 .0002-2A1 1 0 0 0 12 15Zm7-12h-1V2a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 16 2v1H8V2a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v14a2.9998 2.9998 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3Zm1 17a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1v-9h16v9Zm0-11H4V6a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V5h8v1a1.0002 1.0002 0 0 0 1.7071.7071A1.0002 1.0002 0 0 0 18 6V5h1a1 1 0 0 1 1 1v3ZM7 15a.9998.9998 0 0 0 .7071-1.7071A.9998.9998 0 0 0 6 14a1 1 0 0 0 1 1Zm0 4a.9998.9998 0 0 0 .7071-1.7071A.9998.9998 0 0 0 6 18a1 1 0 0 0 1 1Z"/>
  </SvgIcon>
}

export default LineCalendarAltIcon
